import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  provider: Types.OauthProvider;
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly restrictions: { readonly __typename?: 'AccountsRestriction', readonly subaccountsCount?: number | null }, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly isTrial: boolean }, readonly company?: { readonly __typename?: 'AccountsCompany', readonly name: string, readonly token?: { readonly __typename?: 'OauthProviderToken', readonly id: string, readonly accounts: ReadonlyArray<{ readonly __typename?: 'YalperAccount', readonly id: string, readonly name: string }> } | null, readonly accounts: ReadonlyArray<{ readonly __typename?: 'YalperAccount', readonly id: string, readonly name: string, readonly currency: string }> } | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($companyId: ID!, $provider: OauthProvider!) {
  currentUser {
    restrictions {
      subaccountsCount
    }
    subscription {
      isTrial
    }
    company(id: $companyId) {
      name
      token(provider: $provider) {
        id
        accounts {
          id
          name
        }
      }
      accounts(provider: $provider) {
        id
        name
        currency
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;